import type { MantineColorsTuple } from "@mantine/core";

import type { ResolvedColorScheme } from "metabase/lib/color-scheme";
import { ALL_COLOR_NAMES, deriveFullMetabaseTheme } from "metabase/lib/colors";
import type { ColorName, MetabaseColorKey } from "metabase/lib/colors/types";
import type { ColorSettings } from "metabase-types/api";

const ORIGINAL_COLORS = [
  "dark",
  "gray",
  "red",
  "pink",
  "grape",
  "violet",
  "indigo",
  "blue",
  "cyan",
  "green",
  "lime",
  "yellow",
  "orange",
  "teal",
] as const;

export function getColorShades(colorName: string): MantineColorsTuple {
  // yes this is silly, but it makes typescript so happy
  return [
    colorName,
    colorName,
    colorName,
    colorName,
    colorName,
    colorName,
    colorName,
    colorName,
    colorName,
    colorName,
  ];
}

export function getMantineThemeColors(
  colorScheme: ResolvedColorScheme,
  whitelabelColors?: ColorSettings | null,
): Record<string, MantineColorsTuple> {
  const { colors } = deriveFullMetabaseTheme({ colorScheme, whitelabelColors });

  return {
    ...Object.fromEntries(
      ORIGINAL_COLORS.map((name) => [name, getColorShades("transparent")]),
    ),
    ...Object.fromEntries(
      Object.entries(colors).map(([name, value]) => [
        name,
        getColorShades(value),
      ]),
    ),
  };
}

/**
 * css color variable from Metabase's theme
 * @param colorName
 * @returns string referencing a css variable
 */
export function color(colorName: ColorName | string): string {
  if (isColorName(colorName)) {
    return `var(--mb-color-${colorName})`;
  }
  return colorName;
}

export const isColorName = (name?: string | null): name is ColorName => {
  return !!name && ALL_COLOR_NAMES.includes(name as MetabaseColorKey);
};
